const Faq = [
    {
      id: '1',
      question: 'What services do you offer?',
      answer: 'I offer a wide range of services, including frontend development, backend development, accounting solutions, and data analytics. Each service is tailored to meet your specific project needs.',
    },
    {
      id: '2',
      question: 'How can I contact you for a project?',
      answer: 'You can contact me through the contact form on the website or via email. Please provide details about your project, and I will get back to you as soon as possible.',
    },
    {
      id: '3',
      question: 'Do you provide custom solutions?',
      answer: 'Yes, I provide custom solutions based on your requirements. Whether you need a unique web application, a data analysis tool, or a specialized backend, I can develop it according to your needs.',
    },
    {
      id: '4',
      question: 'What technologies do you work with?',
      answer: 'I specialize in a wide range of technologies including React, Node.js, MongoDB, and SQL for web development, as well as various tools for data analytics and accounting services.',
    },
    {
      id: '5',
      question: 'How long does it take to complete a project?',
      answer: 'The time it takes to complete a project depends on its complexity and your specific requirements. After reviewing your project, I will provide you with an estimated timeline.',
    },
    {
      id: '6',
      question: 'Do you offer ongoing support after project completion?',
      answer: 'Yes, I offer ongoing support and maintenance services even after the project is completed to ensure everything runs smoothly and any necessary updates are implemented.',
    },
    {
      id: '7',
      question: 'What is your pricing structure?',
      answer: 'Pricing depends on the scope and complexity of the project. After an initial consultation and understanding of your requirements, I will provide you with a detailed quote.',
    },
    {
      id: '8',
      question: 'Can I see samples of your previous work?',
      answer: 'Yes, you can view my previous projects in the "Projects" section of this portfolio. Each project includes details such as technologies used and a link to the source code or demo.',
    },
  ];
export default Faq;  